export default __webpack_public_path__ + "static/media/Games.4f5aa95d.svg";